/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { FILTER_TYPE } from 'app/models/filter.models';
import { isValueNotEmpty } from 'app/utils/all-data.utils';

import { AllDataFilterDialogComponent } from '../all-data-filter-dialog.component';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-all-data-filter-dialog-button',
  templateUrl: './all-data-filter-dialog-button.component.html',
  styleUrls: ['./all-data-filter-dialog-button.component.scss'],
  imports: [MatIcon],
})
export class AllDataDialogFilterComponent {
  @Input() headerRef!: HTMLDivElement;
  @Input() header = '';
  @Input() data?: any;
  @Input() filterType?: FILTER_TYPE;
  @Input() options?: any;
  @Input() isSingle?: boolean;

  @Output() save = new EventEmitter<any>();

  constructor(public dialog: MatDialog) {}

  get isFilled() {
    return isValueNotEmpty(this.data);
  }

  openFilterPopup(event: Event) {
    event.stopPropagation();

    const { bottom, left, right } = this.headerRef.getBoundingClientRect();
    const coordinates = { bottom, left: left + window.scrollX, right };

    const position: { top: string; right?: string; left?: string } = {
      top: `${coordinates.bottom + 6}px`,
    };

    if (coordinates.left + 300 >= window.innerWidth) {
      position.right = '5px';
    } else {
      position.left = `${coordinates.left}px`;
    }

    const dialogRef = this.dialog.open(AllDataFilterDialogComponent, {
      autoFocus: false,
      backdropClass: 'custom-backdrop',
      position,
      width: '300px',
      data: {
        title: this.header,
        value: this.data,
        type: this.filterType,
        options: this.options,
        isSingle: this.isSingle,
      },
    });

    dialogRef.componentInstance.apply.subscribe((value) => {
      this.save.emit(value);
    });
  }
}
